import { Locale } from "modules/i18n/locale-config";

export default {
  locale: Locale.EN.code,
  messages: {
    "app.save": "Save",
    "app.print": "PRINT",
    "app.previous": "Previous",
    "app.next": "Next",
    "app.start": "Start",
    "root.start-bank-id": "MOBILE BANKID",
    "root.social-security-number": "YYYYMMDDXXXX",
    "app.continue": "Continue",
    "app.got-it": "Got It",
    "app.show-help": "Guidance",
    "app.locale-en": "English",
    "app.locale-sv": "Svenska",
    "app.locale-is": "Icelandic",
    "root.brand": "Healo",
    "root.title": "Self-diagnosis",
    "root.desc": `Welcome to start your journey on the path to pain relief. <br/>Your Self-diagnosis can take a few minutes.`,
    "root.disclaimer":
      "© 2017-" +
      new Date()
        .getFullYear()
        .toString()
        .substr(-2) +
      " Empowered Applications",
    "root.start-diagnosis": "Start",
    "root.start-diagnosis.email": "<b>Start</b> with email",
    "root.sign-up": "Sign-up",
    "root.go-home": "To Start",
    "root.auth.or": "OR",
    "general-info.title": "GENERAL INFO PAGE",
    "general-info-form.sex": "Sex",
    "general-info-form.male": "Male",
    "general-info-form.female": "Female",
    "general-info-form.weight": "Weight (kg)",
    "general-info-form.height": "Height (cm)",
    "general-info-form.age": "Age",
    "general-info-form.first-name": "First Name",
    "general-info-form.last-name": "Last Name",
    "general-info-form.country": "Country",
    "general-info-form.city": "City",
    "general-info-form.language": "Language",
    "initial-diagnostic.title": "Initial Self-diagnosis",
    "locale-switcher.title": "Select language",
    "body-model.rotate": "Rotate body",
    "pain-profile.title": "PAIN PROFILE",
    "modal.instruction": "Instruction",
    "modal.information": "Information",
    "general-info-form.error.sex":
      "You must select your gender. It is necessary if your therapy is to turn out right.",
    "general-info-form.error.weight":
      "You must enter your weight. It is necessary if your therapy is to turn out right.",
    "general-info-form.error.height":
      "You must enter your height. It is necessary if your therapy is to turn out right.",
    "general-info-form.error.age":
      "You have to enter your age. It is necessary if your therapy is to turn out right.",
    "general-info-form.error.first_name.special-characters":
      "First name cannot contain special characters.",
    "general-info-form.error.first_name.length":
      "You must enter your first name.",
    "general-info-form.error.last_name.special-characters":
      "Last name cannot contain special characters.",
    "general-info-form.error.last_name.length":
      "You must enter your last name.",
    "general-info-form.i_am_a": "I am a",
    "general-info-form.i_am_born_on": "I was born",
    "general-info-form.i_am": "I am",
    "general-info-form.years_old": "years old",
    "general-info-form.man": "Man",
    "general-info-form.woman": "Woman",
    "self-diagnostic.finished_desc":
      "Thank you. We have a therapy for you. Please proceed to create an account to save your Self-diagnosis after which you can download the app to start your therapy.",
    "modal.thinking.text": "THINKING",
    "modal.question-changed.text":
      "If you change your answer to this question, you will have to answer the following questions again. Do you want to change your answer?",
    "modal.question-changed.approve": "Yes, change my answer",
    "modal.question-changed.decline": "No, keep my answer",
    "modal.exit-diagnostic.text":
      "Are you sure you want to exit diagnostic? It will remove your current progress.",
    "modal.exit-diagnostic.approve": "Yes",
    "modal.exit-diagnostic.decline": "No",
    "modal.unexpected-error.text":
      "There was an unexpected error, please refresh your browser.",
    "modal.unexpected-error.approve": "Yes, refresh my browser",
    "sign-up.confirm": "Confirm",
    "sign-up.resend-code": "Resend Email",
    "sign-up.confirm-email.header": "Confirm your email",
    "sign-up.create-account.header": "Create account",
    "sign-up.create-account.code_already_sent":
      "Confirmation Email has already been sent to your email address.",
    "sign-up.create-account.wrong_email":
      "Provided email is already used for a Healo account. Either try another email or log in the app and update your Self-diagnosis there.",
    "sign-up.create-password.header": "Create your Password",
    "sign-up.email": "Email",
    "sign-up.phone": "Phone",
    "sign-up.password": "Password",
    "sign-up.confirm-password": "Confirm Password",
    "sign-up.submit-password": "Create",
    "sign-up.code": "Confirmation Code",
    "sign-up.first-name": "First Name",
    "sign-up.last-name": "Last Name",
    "sign-up.sign-up": "Sign up",
    "sign-up.sign-up-facebook": "Continue with Facebook",
    "sign-up.finish_main": "Thank you!",
    "sign-up.finish":
      "Everything is done and you can proceed to install the app Healo and sign in with your new account to start your treatment.",
    "sign-up.error.email": "The email you've entered is invalid",
    "sign-up.error.code":
      "The Confirmation Code you entered is invalid. Check your email again.",
    "sign-up.error.password.missing": "You have to enter your password",
    "sign-up.error.password.missmatch": "Provided passwords do not match",
    "consent.title": "Informed Consent",
    "consent.button": "Consent & Accept",
    "mobile-redirect.part1": "We see that you are using a smartphone.",
    "mobile-redirect.part2":
      "Please download Healo and perform the Self - diagnosis directly in the app!",
    "mobile-redirect.part3": "Thank You!",
    "mobile-redirect-clinic.part1":
      "Tyvärr fungerar inte Självskattningen på en mobil eller liten surfplatta.",
    "mobile-redirect-clinic.part2":
      "Vänligen prova länken igen på en dator eller surfplatta med större skärm.",
    "mobile-redirect-clinic.part3": "Ursäkta detta, och tack för tålamodet!",
    "vas-slider.lvl_1": "No Pain",
    "vas-slider.lvl_1_desc": "Feeling perfectly normal.",
    "vas-slider.lvl_2": "Very Mild",
    "vas-slider.lvl_2_desc":
      "Manageable without effort, but increasingly on my mind.",
    "vas-slider.lvl_3": "Discomforting",
    "vas-slider.lvl_3_desc":
      "Nagging and annoying but does not interfere with most daily living activities.",
    "vas-slider.lvl_4": "Tolerable",
    "vas-slider.lvl_4_desc":
      "I can adapt to the pain psychologically and/or with medication.",
    "vas-slider.lvl_5": "Distressing",
    "vas-slider.lvl_5_desc": "Interferes significantly with daily activities.",
    "vas-slider.lvl_6": "Very Distressing",
    "vas-slider.lvl_6_desc":
      "Pain requires lifestyle changes but I am still independent.",
    "vas-slider.lvl_7": "Intense",
    "vas-slider.lvl_7_desc": "I am unable to adapt to the pain.",
    "vas-slider.lvl_8": "Very Intense",
    "vas-slider.lvl_8_desc":
      "Disabling, I am unable to perform daily living activities.",
    "vas-slider.lvl_9": "Utterly Horrible",
    "vas-slider.lvl_9_desc": "I am unable to engage in normal activities.",
    "vas-slider.lvl_10": "Excruciating and unbearable pain",
    "vas-slider.lvl_10_desc":
      "I am disabled and unable to function independently.",
    "vas-slider.lvl_11": "Unimaginable pain",
    "vas-slider.lvl_11_desc": "Worst imaginable pain, words can't describe it.",
    "sign-up.error.password.short":
      "Your password must consist of at least six characters.",
    "consent.desc":
      "Healo is a CE certified application. Before you proceed, you must <b>Consent</b> to the terms in our Medical Disclaimer and <b>Accept</b> our Terms of Use and Privacy Policy. It is important that you read these Terms carefully. You may revoke your consent in the future.",
    "consent.checkbox.medical": "Medical Disclaimer",
    "consent.checkbox.medical.description":
      "By using Healo, you receive preventive exercise and/or help to achieve pain relief through self-care of musculoskeletal disorders. Healo is not a substitute for professional medical advice.",
    "consent.checkbox.terms": "Terms of Use",
    "consent.checkbox.terms.description":
      "By accessing, browsing, or using Healo you accept our Terms of Use.",
    "consent.checkbox.privacy": "Privacy Policy",
    "consent.checkbox.privacy.description":
      "By using Healo, you consent to Healo’s handling of your Personal Data. Healo ensures that all handling and processing of your data is performed in accordance with EU and international regulation and law.",
    "sign-up.create-acc":
      "In order to access your therapy in our mobile app, please register an account with Healo.",
    "sign-up.check-email":
      "Check your email. We have sent you a confirmation code. {break} Please insert it here",
    "sign-up.create-password": "Now, create your account password.",
    "human.select-zones": "Select the zone where your pain is located.",
    "human.select-zones-desctiption":
      "If you have several pains or problems, focus only on that which is most painful or troubling, and select only those zones. Your other problems can be Self-diagnosed in the app later.",
    "human.ok-button": "OK",
    "sex_and_age.weight_validation": "Please enter your correct weight.",
    "sex_and_age.height_validation": "Please enter your correct height.",
    "sex_and_age.required": "This Field is required.",
    "diagnosis_finished.text_rf":
      "We analysed your answers and you have received a Red Flag, meaning that there are certain indicators that need to be examined by a qualified medical professional. We recommend that you contact your healthcare provider as soon as possible to have this problem examined.",
    "diagnosis_finished.text_rf_extended":
      "Please proceed to create your Healo account (next screen) to save the result from your Self-diagnosis (it will otherwise be erased), then download the app, sign in (with your new account.{break}If you have questions about your Self-diagnosis and the result, please still register an account, download and sign in, and then get in touch with our clinical staff via Healo's chat.",
    "diagnosis_finished.text_of":
      "We've analysed your answers and we're happy to inform that we have a treatment ready and waiting for you in the Healo app!",
    "diagnosis_finished.text_of_extended":
      "But, you've also received an Orange Flag, meaning that there are certain indicators that need to be examined by a qualified medical professional. To ensure that you receive the best possible care we recommend that you, within a week's time, contact your regular healthcare provider to have this problem examined.{break}That said, it is a good thing that you have decided to get working on your problem. Hopefully performing rehab sessions can alleviate symptoms while you wait to meet the professional.{break}Please proceed to create your Healo account (next screen) to save the result from your Self-diagnosis (it will otherwise be erased), then download the app, sign in (with your new account), and start your treatment.{break}If you have questions about your Self-diagnosis and the result, please still register an account, download and sign in, and then get in touch with our clinical staff via Healo's chat.",
    "diagnosis_finished.text_l_yf":
      "We've analysed your answers and we're happy to inform that we have a treatment ready and waiting for you in the Healo app!",
    "diagnosis_finished.text_l_yf_extended":
      "But, you've also received a Yellow Flag, meaning that your Self-diagnosis answers indicate factors in your life that may lead to development of long-term inconveniences, or that may affect your rehabilitation and extend the time it takes for you to become healthy and pain-free. The factors may include, for example, your general state of health, stress, or sleep problems. You will find more information regarding this in the app.{break}That said, it is a good thing that you have decided to get working on your problem today, as that will probably help you stop these issues from developing in the wrong direction!{break}Please proceed to create your Healo account (next screen) to save the result from your Self-diagnosis (it will otherwise be erased), then download the app, sign in (with your new account), and start your treatment!{break}If you have questions about your Self-diagnosis and the result, please still register an account, download and sign in, and then get in touch with your Health Care provide via Healo's chat.",
    "diagnosis_finished.text_q_yf":
      'We analysed your answers and there are certain indicators that need to be examined in detail. In order to create a treatment for you, we need some more information.{break}Please proceed to create your Healo account (next screen) in order to save the result from your Self-diagnosis (it will otherwise be erased), then download the app and sign in (with your new account).{break}When you have installed and launched Healo, please navigate to Pain Profile and tap the button "Add therapy" to perform an Extensive Self-diagnosis. {break}If you have questions about your Self-diagnosis and the result, please still register an account, download and sign in, and then get in touch with your Health Care provider via Healo\'s chat.',
    "diagnosis_finished.text_q_yf_extended": " ",
    "diagnosis_finished.text_default":
      "We've analysed your answers and we're happy to inform that we have a treatment ready and waiting for you in the Healo app!{break}Please proceed to create your Healo account (next screen) to save the result from your Self-diagnosis (it will otherwise be erased), then download the app, sign in (with your new account), and start your treatment!",
    "diagnosis_finished.text_default_extended":
      "If you have questions about your Self-diagnosis and the result, please still register an account, download and sign in, and then get in touch with your Health Care Provider via Healo's chat.",
    "diagnosis_finished.proceed": "Proceed",
    "self-diagnostic.finished": "Thank you for completing the Self-diagnosis!",
    "self-diagnostic.finished_q_yf": "Quick Self-diagnosis is not sufficient.",
    "consent-modal.i_consent": "Consent",
    "sign-up-clinic.finish":
      "Everything is done and your Care provider has been notified about your results.",
    "sign-up-clinic.finish_2":
      "You can now proceed to install the app Healo and sign in with your new account to start your treatment.",
    "sign-up-clinic.finish_3":
      "Your Care provider will get in touch with you in the Healo Chat.",
    "sign-up.error.clinic_city": "Please select your clinic",
    "sign-up.clinic_city_default": "Please select your clinic",
    "bank_id.error_400": "Error with Bank ID service",
    "root.loading": "Verifying",
    "root.check_your_device": "Open your BankID",
    "ssn_validation.empty-ssn": "Please enter your 12 digit SSN",
    "ssn_validation.ssn-too-long":
      "Please enter your SSN using 12 digits (YYYYMMDDXXXX)",
    "ssn_validation.ssn-too-short":
      "Please enter your SSN using 12 digits (YYYYMMDDXXXX)",
    "bank_id.error_406": "User already registered in App",
    "root.identify-bank-id": "Identify with BankID",
    "root.identify-bank-id--description":
      "Start the BankID app and scan the QR code.",
    "root.open-bank-id--device": "Open BankID on this device instead"
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/default/messages/en.js